import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

const AppContext = createContext();

function useStore() {
  return useContext(AppContext);
}

export { AppContext, useStore };
